import { createContext, useContext, useState } from "react";

export const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        let theme = localStorage.getItem("theme")
        if (!theme) {
            localStorage.setItem("theme", "light")
            theme = localStorage.getItem("theme")
        }
        return theme
    })
    const toggleTheme = () => {
        setTheme((current) => {
            const newTheme = current === "light" ? "dark" : "light"
            localStorage.setItem("theme", newTheme)
            return newTheme
        })
    }
    return (
        <ThemeContext.Provider value={[ theme, toggleTheme]}>
            {children}
        </ThemeContext.Provider>
    )
}

export default function useTheme() {
    return useContext(ThemeContext)
}